import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { env } from '@bridebook/web/lib/env';

export const BusinessLoginButton: FC = () => {
  const { t } = useTranslation('common');

  return (
    <Link href={`${env.CMS_URL}/login`}>
      <button className="bcb bcx">{t('businessLogin')}</button>
    </Link>
  );
};
